export const BOARDING_CONFLICT = 0
export const COMPONENT_WEIGHT = 1
export const DELAY = 2
export const CURFEW = 3
export const TAIL_SWAP = 4
export const ETD_STD_DIFF= 5
export const EDCT = 6
export const UNDEFINED = -1
